/**
 * Archive 档案管理库
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Message, Modal, Button, Dropdown, DropdownMenu, DropdownItem,Select,Option } from "view-design";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Select', Select);
Vue.component('Option', Option);
import { getArchiveClassAllService} from '@/service/device-class-service'
import { mapMutations, mapState } from "vuex";
import $event, { EVENT_NAME } from "@/utils/event-emitter";
const Archive = {
    name:'Archive',
    computed: {
        ...mapState({
            selectedMenuId: state => state.system.selectedMenuId, //选中的菜单Id
            menuVisible: state => state.system.menuVisible, //菜单显示状态
            deviceScrollTop: state => state.system.deviceScrollTop, //滚动条高度
        }),
    },
    data() {
        return {
            windowWidth:window.innerWidth, //获取窗口宽度
            deviceModalVisible:false, //设备分类modal弹框可显示
            deviceLoading:false, //设备分类modal弹框 loading
            deviceListArray:[], //设备分类数据
            deviceTypeList:[], //设备分类二级数据
            deviceName:'', //设备名称
            deviceId:'', //设备id
            deviceType:'', //设备分类
            btnStatus:false, //按钮状态
        }
    },
    created() {
        this.onArchiveClassAll().then(()=>{
            if(this.deviceScrollTop === undefined){
                this.SET_DEVICE_SCROLL_TOP(0)
                this.$refs.menuListRef.scrollTop = 0
            }else{
                this.$refs.menuListRef.scrollTop = this.deviceScrollTop
            }
        })
    },
    methods: {
        ...mapMutations('system',['SET_CLASSIFY_MENU_ARRAY','SET_SELECTED_MENU_ID','SET_DEVICE_SCROLL_TOP','SET_FILE_SELECT','SET_ARCHIVE_MENU_NAME']),

        /**
         * 跳转携带id
         * @param id
         */
        onLinks(device,childrenId,childId){
            this.SET_DEVICE_SCROLL_TOP(document.getElementById('menuList').scrollTop)
            this.SET_SELECTED_MENU_ID([-1,childrenId,childId])
            this.SET_FILE_SELECT([])
            if(device.label === undefined){
                this.SET_ARCHIVE_MENU_NAME('')
            }else{
                this.SET_ARCHIVE_MENU_NAME(device.label)
            }
            if(this.$route.path!=='/archive/list'){
                this.$router.push('/archive/list')
            }else{
                $event.$emit(EVENT_NAME.ARCHIVE_MENU_LIST)
            }
        },
        /**
         * 添加根结点设备
         */
        onAddDevice(){
            this.btnStatus = true
            this.deviceModalVisible = true
            this.deviceName = ''
            this.deviceId = ''
        },
        /**
         * 添加设备分类验证
         */
        onAddDeviceCheck(){
            if(this.deviceName === ''){
                Message.error('请输入管理名称！')
                return;
            }
            this.btnStatus?this.onAddDeviceClass().then():this.onUpdateDeviceClass().then()

        },
        /**
         * 添加二级设备
         * @param id
         */
        onChildAddDevice(id){
            this.btnStatus = true
            this.deviceModalVisible = true
            this.deviceName = ''
            this.deviceId = id
        },
        /**
         * 修改设备分类
         * @param id
         */
        onUpdateDevice(obj,type){
            this.btnStatus = false
            this.deviceModalVisible = true
            this.deviceName = obj.label
            this.deviceId = obj.value
            this.deviceType = type
        },
        /**
         * 删除设备
         * @param id
         */
        onDelDevice(id){
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除吗？</p>',
                loading:true,
                onOk: () => {
                    this.onDelDeviceClass(id).then()
                }
            });
        },
        /**
         * 获取所有档案目录
         */
        async onArchiveClassAll() {
            try {
                const { code,data } = await getArchiveClassAllService()
                if(code === 'SUCCESS'){
                    for(let i in data){
                        data[i].name = '目录'
                        data[i].visible = true
                        data[i].id = -1
                        if(data[i].childNode.length!==0){
                            for(let j in data[i].childNode){
                                data[i].childNode[j].visible = true
                            }
                        }
                    }
                    this.deviceListArray = this.onReplaceAttribute(data)
                    this.deviceTypeList = this.deviceListArray[0].children
                    this.SET_CLASSIFY_MENU_ARRAY(this.deviceListArray)
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 替换属性名
         * @param data
         */
        onReplaceAttribute(data){
            let item = []
            data.map(list => {
                let newData = {}
                newData.value = list.id;
                newData.label = list.name;
                newData.visible = list.visible;
                newData.children = list.childNode;
                if(list.childNode){
                    newData.children = this.onReplaceAttribute(list.childNode)
                }
                item.push(newData)
            })
            return item
        },
    },
    destroyed () {
    }
}
export default Archive
